import { fetchAnchorPKList } from '@/services/activity';
import { TIME } from '@/page/anchorPK/config';

export default {
  namespace: 'anchorPK',
  state: {
    list: {},
    dateTab: TIME.DAILY,
  },
  reducers: {
    updateList(state, { payload }) {
      return {
        ...state,
        list: payload,
      };
    },
    updateDate(state, { payload }) {
      return {
        ...state,
        dateTab: payload,
      };
    },
  },
  effects: {
    *fetchAnchorPKList({ payload }, { call, put }) {
      const res = yield call(fetchAnchorPKList, payload);
      yield put({
        type: 'updateList',
        payload: res.data,
      });
      return res;
    },
    *updatesDate({ payload }, { put }) {
      yield put({
        type: 'updateDate',
        payload: payload,
      });
    },
  },
};
